import store from "@/store";
import { computed, watch } from "vue";

export function colorCheck(primaryColor: string) {
  const parsedHex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(primaryColor);
  const rgb = parsedHex
    ? {
        r: parseInt(parsedHex[1], 16),
        g: parseInt(parsedHex[2], 16),
        b: parseInt(parsedHex[3], 16),
      }
    : null;

  if (rgb !== null) {
    // determine if light or dark theme is needed
    const luminance = Math.round((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000);

    // Adding else statement just in case client changes. Mainly for testing...
    if (luminance > 118) {
      document.body.classList.add("cuscd-dark");
    } else {
      document.body.classList.remove("cuscd-dark");
      store.dispatch("applicationsModule/setTextColor", "#ffffff");
    }
  }
}

export default function useLender(getLenderId: () => null | number) {
  const lenderId = computed(() => Number(getLenderId()));
  const lenderBranding = computed(() => store.getters["applicationsModule/Branding"]);

  watch(
    lenderId,
    (newValue, oldValue) => {
      store.dispatch("applicationsModule/setLenderId", newValue);

      if (lenderBranding.value?.primaryColor) {
        colorCheck(lenderBranding.value?.primaryColor);
      }
    },
    { immediate: true },
  );

  return { lenderId, lenderBranding };
}
